// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Float from "rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactFeather from "react-feather";
import * as Utils$Coronate from "../Utils.res.js";
import * as Router$Coronate from "../Router.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Data_Rounds$Coronate from "../Data/Data_Rounds.res.js";
import * as Webapi__Dom__Element from "rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.res.js";
import VisuallyHidden from "@reach/visually-hidden";

function makeDateInput(date) {
  var year = String(date.getFullYear());
  var rawMonth = date.getMonth();
  var rawDate = date.getDate();
  var month = rawMonth < 9.0 ? "0" + String(rawMonth + 1.0) : String(rawMonth + 1.0);
  var day = rawDate < 10.0 ? "0" + String(rawDate) : String(rawDate);
  return year + "-" + month + "-" + day;
}

function PageTourneySetup(props) {
  var tournament = props.tournament;
  var tourney = tournament.tourney;
  var roundList = tourney.roundList;
  var date = tourney.date;
  var name = tourney.name;
  var setTourney = tournament.setTourney;
  var match = React.useState(function () {
        return "NotEditing";
      });
  var setEditing = match[1];
  var editing = match[0];
  var nameInput = React.useRef(null);
  var dateInput = React.useRef(null);
  var focusRef = function (myref) {
    Belt_Option.map(Belt_Option.flatMap(Caml_option.nullable_to_opt(myref.current), Webapi__Dom__Element.asHtmlElement), (function (prim) {
            prim.focus();
          }));
  };
  React.useEffect((function () {
          switch (editing) {
            case "Name" :
                focusRef(nameInput);
                break;
            case "Date" :
                focusRef(dateInput);
                break;
            case "NotEditing" :
                break;
            
          }
        }), [editing]);
  var changeByes = function (bye, s) {
    setTourney({
          id: tourney.id,
          name: tourney.name,
          date: tourney.date,
          playerIds: tourney.playerIds,
          scoreAdjustments: tourney.scoreAdjustments,
          byeQueue: tourney.byeQueue,
          tieBreaks: tourney.tieBreaks,
          roundList: Data_Rounds$Coronate.updateByeScores(roundList, bye)
        });
    window.alert("Bye scores updated to " + s + ".");
  };
  var updateDate = function ($$event) {
    var rawDate = $$event.currentTarget.value;
    var match = rawDate.split("-");
    var match$1;
    if (match.length !== 3) {
      match$1 = [
        "2000",
        "01",
        "01"
      ];
    } else {
      var year = match[0];
      var month = match[1];
      var day = match[2];
      match$1 = [
        year,
        month,
        day
      ];
    }
    var year$1 = Belt_Float.fromString(match$1[0]);
    var month$1 = Belt_Float.fromString(match$1[1]);
    var date = Belt_Float.fromString(match$1[2]);
    if (year$1 !== undefined && month$1 !== undefined && date !== undefined) {
      return setTourney({
                  id: tourney.id,
                  name: tourney.name,
                  date: new Date(year$1, month$1 - 1.0, date),
                  playerIds: tourney.playerIds,
                  scoreAdjustments: tourney.scoreAdjustments,
                  byeQueue: tourney.byeQueue,
                  tieBreaks: tourney.tieBreaks,
                  roundList: tourney.roundList
                });
    }
    
  };
  var tmp;
  var exit = 0;
  switch (editing) {
    case "Name" :
        tmp = JsxRuntime.jsxs("form", {
              children: [
                JsxRuntime.jsx("input", {
                      ref: Caml_option.some(nameInput),
                      className: "display-20",
                      style: {
                        textAlign: "left"
                      },
                      type: "text",
                      value: name,
                      onChange: (function ($$event) {
                          setTourney({
                                id: tourney.id,
                                name: $$event.currentTarget.value,
                                date: tourney.date,
                                playerIds: tourney.playerIds,
                                scoreAdjustments: tourney.scoreAdjustments,
                                byeQueue: tourney.byeQueue,
                                tieBreaks: tourney.tieBreaks,
                                roundList: tourney.roundList
                              });
                        })
                    }),
                " ",
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx(ReactFeather.Check, {}),
                      className: "button-ghost",
                      onClick: (function (param) {
                          setEditing(function (param) {
                                return "NotEditing";
                              });
                        })
                    })
              ],
              className: "display-20",
              style: {
                textAlign: "left"
              },
              onSubmit: (function (param) {
                  setEditing(function (param) {
                        return "NotEditing";
                      });
                })
            });
        break;
    case "Date" :
    case "NotEditing" :
        exit = 1;
        break;
    
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsxs("h1", {
          children: [
            JsxRuntime.jsx("span", {
                  children: name,
                  className: "inputPlaceholder"
                }),
            " ",
            JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx(ReactFeather.Edit, {}),
                    JsxRuntime.jsx(VisuallyHidden, {
                          children: "Edit name"
                        })
                  ],
                  className: "button-ghost",
                  onClick: (function (param) {
                      setEditing(function (param) {
                            return "Name";
                          });
                    })
                })
          ],
          style: {
            textAlign: "left"
          }
        });
  }
  var tmp$1;
  var exit$1 = 0;
  switch (editing) {
    case "Date" :
        tmp$1 = JsxRuntime.jsxs("form", {
              children: [
                JsxRuntime.jsx("input", {
                      ref: Caml_option.some(dateInput),
                      className: "caption-30",
                      type: "date",
                      value: makeDateInput(date),
                      onChange: updateDate
                    }),
                " ",
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx(ReactFeather.Check, {}),
                      className: "button-ghost",
                      onClick: (function (param) {
                          setEditing(function (param) {
                                return "NotEditing";
                              });
                        })
                    })
              ],
              className: "caption-30",
              onSubmit: (function (param) {
                  setEditing(function (param) {
                        return "NotEditing";
                      });
                })
            });
        break;
    case "Name" :
    case "NotEditing" :
        exit$1 = 1;
        break;
    
  }
  if (exit$1 === 1) {
    tmp$1 = JsxRuntime.jsxs("p", {
          children: [
            JsxRuntime.jsx(Utils$Coronate.DateFormat.make, {
                  date: date
                }),
            " ",
            JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx(ReactFeather.Edit, {}),
                    JsxRuntime.jsx(VisuallyHidden, {
                          children: "Edit date"
                        })
                  ],
                  className: "button-ghost",
                  onClick: (function (param) {
                      setEditing(function (param) {
                            return "Date";
                          });
                    })
                })
          ],
          className: "caption-30"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                tmp,
                tmp$1,
                JsxRuntime.jsx("h2", {
                      children: "Change all bye scores"
                    }),
                JsxRuntime.jsx("button", {
                      children: "Change byes to 1",
                      "aria-describedby": "score-desc",
                      onClick: (function (param) {
                          changeByes("Full", "1");
                        })
                    }),
                " ",
                JsxRuntime.jsx("button", {
                      children: "Change byes to ½",
                      "aria-describedby": "score-desc",
                      onClick: (function (param) {
                          changeByes("Half", "½");
                        })
                    }),
                " ",
                JsxRuntime.jsx("button", {
                      children: "Change byes to 0",
                      "aria-describedby": "score-desc",
                      onClick: (function (param) {
                          changeByes("Zero", "0");
                        })
                    }),
                JsxRuntime.jsxs("p", {
                      children: [
                        "This will update ",
                        JsxRuntime.jsx("em", {
                              children: "all"
                            }),
                        " bye matches which have been previously scored in this\n      tournament, including ones that were added manually. To change the default\n      bye value in future matches, go to the ",
                        JsxRuntime.jsx(Router$Coronate.Link.make, {
                              children: "app options",
                              to_: "Options"
                            }),
                        "."
                      ],
                      className: "caption-30",
                      id: "score-desc"
                    })
              ],
              className: "content-area"
            });
}

var make = PageTourneySetup;

export {
  make ,
}
/* react Not a pure module */
